let baseUrl;
// baseUrl = "http://localhost:5000/api";
baseUrl = "/api"

export default baseUrl;